import { render, staticRenderFns } from "./PrintSoal.vue?vue&type=template&id=348114a4&scoped=true"
import script from "./PrintSoal.vue?vue&type=script&lang=js"
export * from "./PrintSoal.vue?vue&type=script&lang=js"
import style0 from "./PrintSoal.vue?vue&type=style&index=0&id=348114a4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348114a4",
  null
  
)

export default component.exports